<template>
  <a @click="openPlace" class="block bg-white mr-4 border border-section_border rounded p-2 w-48 overflow-hidden">
    <progressive-img
      :src="recommend.image ? recommend.image : require('@/assets/images/no-image.jpg')"
      :fallback="require('@/assets/images/no-image.jpg')"
      class="w-full h-24"
    />
    <h2 class="mt-2 text-sm font-bold truncate">{{ recommend.name }}</h2>
  </a>
</template>

<script>
import { event } from 'vue-gtag'

export default {
  props: {
    recommend: {
      type: Object
    }
  },
  methods: {
    openPlace: function () {
      event("おすすめスポット詳細", {
        recommend_id: this.recommend.id,
        recommend_name: this.recommend.name
      });
      this.$store.dispatch('drawer/showButton')
      this.$store.dispatch('drawer/openPlace', { place: this.recommend, full: true })
    }
  },
}
</script>
